import React from "react"
import PropTypes from "prop-types"
import { primitives } from '@lexody/design-tokens'
import StandardModal from '../app_components/StandardModal';
import Icon from '../app_components/Icon';
import TextInput from '../form_sections/TextInput';
import DateInput from '../form_sections/DateInput';
import TimeInput from '../form_sections/TimeInput';
import StandardButton from '../app_components/StandardButton';

class LexForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      date: '',
      time: '',
      location: '',
      location_address: '',
      otherUser: [],
      currentUser: [],
      nativeLanguage: [],
      learningLanguage: [],
      learningLanguageChoices: [],
      nativeLanguageChoices: [],
      languagesLoaded: false,
      formError: '',
      scheduleSuccess: false,
      rescheduleSuccess: false,
      meeting: ''
    }

    this.renderLanguageChoices = this.renderLanguageChoices.bind(this)
    this.renderLanguageExample = this.renderLanguageExample.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.languageChoices = this.languageChoices.bind(this)
  }

  componentDidMount() {
    this.setState({
      otherUser: this.props.otherUser,
      currentUser: this.props.currentUser,
      learningLanguage: this.props.learningLanguage,
      learningLanguageChoices: this.props.learningLanguageChoices,
      nativeLanguage: this.props.nativeLanguage,
      nativeLanguageChoices: this.props.nativeLanguageChoices,
      date: this.props.date,
      time: this.props.time,
      location: this.props.location,
      location_address: this.props.location_address,
    })
  }

  renderLanguageExample() {
    return(
      <div className="lex-form__explainer">
        <h3 className="lex-form__explainerTitle">Lex = Language Experience</h3>
        <p className="lex-form__explainerText">You and {this.state.otherUser.first_name} will meet for 1 hour.</p>
        <p className="lex-form__explainerText">
          Speak only in <strong>{this.state.learningLanguage.language}</strong> for 30 minutes.
        </p>
        <p className="lex-form__explainerText">
          Then, speak only in <strong>{this.state.nativeLanguage.language}</strong> for 30 minutes.
        </p>
      </div>
    )
  }

  renderLanguageChoices() {
    return (
      <div className="lex-form__section">
        <h3 className="lex-form__sectionTitle">I want to practice...</h3>
        <div className="lex-form__languageOptions">
          {this.languageChoices()}
        </div>
      </div>
    )
  }

  languageChoices() {
    return this.state.learningLanguageChoices.map((language, index) => {
      const isSelected = this.state.learningLanguage.id === language.id

      return (
        <label
          key={index}
          className={`lex-form__languageOption${isSelected ? ' lex-form__languageOption--selected' : ''}`}
        >
          <input
            type="radio"
            name="learningLanguage"
            checked={isSelected}
            onChange={() => this.setState({ learningLanguage: language })}
          />
          <span>{language.native}</span>
        </label>
      )
    })
  }

  submitForm() {
    if(!this.props.submittingForm){
      if(this.state.date === '') {
        this.setState({
          formError: 'Missing date. What day do you want to Lex?'
        })
      } else if (this.state.time === '') {
        this.setState({
          formError: 'Missing time. What time do you want to Lex?'
        })
      }  else if (this.state.location === '') {
        this.setState({
          formError: 'Missing location. Where do you want to Lex?'
        })
      } else if (this.state.location.length < 3) {
        this.setState({
          formError: 'Location is too short. Where do you want to Lex?'
        })
      } else if (this.state.location_address === '') {
        this.setState({
          formError: 'Location address missing. What is the address? If online, what is your username?'
        })
      } else if (this.state.location_address.length < 5) {
        this.setState({
          formError: 'Location address is too short. What is the address? If online, what is your username?'
        })
      } else {
        const data = {
          requestee_id: this.state.otherUser.id,
          meeting_time: `${this.state.date.toString().split('00:', [1])}, ${this.state.time}`,
          location: this.state.location,
          location_address: this.state.location_address,
          lang_one_id: this.state.learningLanguage.id,
          lang_two_id: this.state.nativeLanguage.id
        }

        this.props.submitForm(data)
      }
    }
  }

  render() {
    return(
      <StandardModal
        onClose={this.props.onClose}
        title={`Schedule a Lex with ${this.state.otherUser.first_name}`}
        size="wide"
        modalClass="standardModal--lexForm"
      >
        <div className="lex-form">
          <header className="lex-form__header">
            <div className="lex-form__titleRow">
              <span className="lex-form__iconCircle" aria-hidden="true">
                <Icon name="schedule" size={20} color={primitives.violet['700']} />
              </span>
              <h2 className="lex-form__title">
                Schedule a Lex with {this.state.otherUser.first_name}
              </h2>
            </div>
          </header>

          {this.renderLanguageExample()}
          {this.state.learningLanguageChoices.length > 1 && this.renderLanguageChoices()}

          <div className="lex-form__section">
            <h3 className="lex-form__sectionTitle">When</h3>
            <div className="lex-form__fieldRow">
              <div className="lex-form__field">
                <DateInput
                  label="Date"
                  value={this.state.date}
                  inputError=""
                  onChange={(value) => this.setState({ date: value, formError: '' })}
                  placeholder=""
                  minDate={Date.now() + (3600 * 1000 * 24)}
                  maxDate={Date.now() + (3600 * 1000 * 24 * 21)}
                  tone="green"
                />
              </div>
              <div className="lex-form__field">
                <TimeInput
                  label={'Time'}
                  value={this.state.time}
                  inputError={''}
                  onChange={(value) => this.setState({time: value, formError: ''})}
                  placeholder={''}
                />
              </div>
            </div>
          </div>

          <div className="lex-form__section">
            <h3 className="lex-form__sectionTitle">Where</h3>
            <p className="lex-form__hint">
              We suggest meeting online — Skype, Messenger, WeChat, or another free video chat service.
            </p>
            <div className="lex-form__field">
              <TextInput
                label="Location Name"
                value={this.state.location}
                inputError=""
                onChange={(value) => this.setState({ location: value, formError: '' })}
                placeholder="ex. Starbucks, Skype"
                icon="map-marker"
                tone="blue"
              />
            </div>
            <div className="lex-form__field">
              <TextInput
                label="Location Address"
                value={this.state.location_address}
                inputError=""
                onChange={(value) => this.setState({ location_address: value, formError: '' })}
                placeholder="ex. 123 Starbucks St, Skype name"
                icon="building"
                tone="violet"
              />
            </div>
          </div>

          <div className="lex-form__actions">
            {this.state.formError !== '' && (
              <p className="lex-form__error" role="alert">{this.state.formError}</p>
            )}
            <StandardButton
              text="Request Lex"
              size="large"
              primary={true}
              fullWidth
              onClick={this.submitForm}
              loading={this.props.submittingForm}
            />
            <p className="lex-form__reward">
              Earn <strong>5</strong>
              <span className="lex-form__rewardCoin lexicoin" aria-hidden="true" />
              per Lex
            </p>
          </div>
        </div>
      </StandardModal>
    )
  }
}

export default LexForm
